import { render } from "./Destination.vue?vue&type=template&id=93245620"
import script from "./Destination.vue?vue&type=script&lang=js"
export * from "./Destination.vue?vue&type=script&lang=js"
script.render = render

export default script